import type { Sort } from 'components/atoms/Table/table.types';
import type { FC } from 'react';
import type { DocumentItem } from 'types/repository.types';
import type { Transaction } from 'types/transactions.types';
import DocumentsList from './List/List.component';

export type DocumentsTableProps = {
  data: DocumentItem[];
  isLoading: boolean;
  isError: boolean;
  tableSorter: { cellId: string; direction: Sort };
  setTableSort: (cellId: string) => void;
  onRetry: () => void;
  isEmpty: boolean;
  selectedRows: string[];
  setSelectedRows: (ids: string[]) => void;
  highlight: string[];
  page: number;
  animated?: boolean;
  selectableRows?: boolean;
  onDelete?: (transaction: Transaction) => void;
  onRowClick: (_id: string, item?: DocumentItem) => void;
  afterFlash?: (id: string) => void;
  flash?: string[];
};

const DocumentsTable: FC<DocumentsTableProps> = ({
  data,
  isLoading,
  isError,
  tableSorter,
  setTableSort,
  onRetry,
  selectedRows,
  setSelectedRows,
  highlight,
  page,
  animated = true,
  selectableRows = true,
  onDelete,
  onRowClick,
  flash,
  afterFlash,
}) => {
  return (
    <DocumentsList
      sorter={tableSorter}
      onSort={setTableSort}
      selectableRows={selectableRows}
      selected={selectedRows}
      setSelected={setSelectedRows}
      highlight={highlight}
      page={page}
      animated={animated}
      documents={data}
      onRowClick={onRowClick}
      flash={flash}
      afterFlash={afterFlash}
    />
  );
};

export default DocumentsTable;
